/* global firac:false */
class FairsArchive {
  constructor(selector) {
    this.element = document.querySelector(selector);

    if (this.element) {
      this.filters = {
        year: new Date().getFullYear(),
        keyword: '',
        month: 'all',
        sector: 'all',
        actuality: 'current',
        enabled: false
      };

      this.layout = 'grid';
      this.order = 'original-order';
      this.resultHtml = '';
      this.numberOfElements = 0;

      this.wrapper = document.querySelector('#blog-entries');
      this.categoryFilter = document.querySelector('.category-filter');
      this.loader = this.element.querySelector('.loader');

      this.init();
    }
  }

  init() {
    if (this.filters.sector === 'all' && this.categoryFilter) {
      this.categoryFilter.style.display = 'none';
    }

    this.registerEvent();
    this.initIsotope();
  }

  initIsotope() {
    const that = this;
    const filter = function () {
      let validMonth, validSector, validKeyword;
      const currentMonth = this.getAttribute('data-month');
      const currentTerms = this.getAttribute('data-terms');
      const currentKeywords = this.getAttribute('data-keywords').toLowerCase();

      if (that.filters.enabled) {
        validMonth = that.filters.month === 'all' || that.filters.month.includes(currentMonth);
        validSector = that.filters.sector === 'all' || currentTerms.indexOf(that.filters.sector) !== -1;
        validKeyword = that.filters.keyword === '' || currentKeywords.indexOf(that.filters.keyword) !== -1;

        return validMonth && validSector && validKeyword;
      }

      return true;
    };

    this.grid = new Isotope(this.wrapper, {
      itemSelector: 'article',
      layoutMode: 'packery',
      packery: {
        gutter: '.gutter-sizer'
      },
      percentPosition: true,
      filter: filter,
      getSortData: {
        category: '[data-keywords]',
      }
    });

    this.grid.on('arrangeComplete', function (filteredItems) {
      const event = new CustomEvent('gridArrangeComplete', {'items': filteredItems.length});

      window.dispatchEvent(event);
    });

    this.fetchData();
  }

  customFiltering() {
    this.grid.arrange();

    this.numberOfElements = this.grid.filteredItems.length;

    this.checkIfEmptyResults();
  }

  checkIfEmptyResults() {
    const noResults = document.querySelector('.filter-no-results');

    if (noResults) {
      noResults.style.display = this.numberOfElements > 0 ? 'none' : 'block';
    }
  }

  registerEvent() {
    let years, title;
    const ajaxInput = document.querySelector('#filters-searchform-ajax input');
    const ajaxMonth = document.querySelector('#filter-month-ajax');
    const ajaxSector = document.querySelector('#filter-sector-ajax');
    const alphaFilter = document.querySelectorAll('.filter-alphabetical');
    const yearLinks = document.querySelectorAll('.date-filters__years-list__year a[data-year]');
    const layoutSelector = document.querySelectorAll('.blog__filters__visualization .layout-selector');
    const backLink = this.categoryFilter.querySelector('.category-filter__back');

    if (ajaxInput) {
      ajaxInput.addEventListener('keyup', event => {
        const el = event.currentTarget;

        this.filters.enabled = true;
        this.filters.keyword = el.value.toLowerCase();

        this.customFiltering();
      });
    }

    if (yearLinks.length) {
      years = document.querySelectorAll('.date-filters__years-list__year');
      title = document.querySelector('.date-filters__years-title');

      yearLinks.forEach(link => {
        link.addEventListener('click', event => {
          const el = event.currentTarget;
          const parent = el.parentNode;

          event.preventDefault();

          if (!parent.classList.contains('date-filters__years-list__year--active')) {

            this.filters.year = el.dataset.year;
            this.filters.actuality = el.dataset.actuality !== undefined ? 'current' : 'all';
            this.fetchData().then(() => {
              years.forEach(year => {
                year.classList.remove('date-filters__years-list__year--active');
              });

              parent.classList.add('date-filters__years-list__year--active');
              title.innerText = this.filters.year;
            });
          }
        });
      });
    }

    if (ajaxMonth) {
      ajaxMonth.addEventListener('change', event => {
        const el = event.currentTarget;

        this.filters.enabled = true;
        this.filters.month = el.value;

        this.customFiltering();
      });
    }

    if (ajaxSector) {
      ajaxSector.addEventListener('change', event => {
        const el = event.currentTarget;
        const categoryTitle = this.categoryFilter.querySelector('.category-filter__title');

        this.filters.enabled = true;
        this.filters.sector = el.value;

        this.categoryFilter.style.display = this.filters.sector === 'all' ? 'none' : 'block';

        if (this.filters.sector !== 'all') {
          categoryTitle.innerText = el.options[el.selectedIndex].innerText;
        }

        this.customFiltering();
      });
    }

    if (layoutSelector.length) {
      layoutSelector.forEach(selector => {
        selector.addEventListener('click', event => {
          const el = event.currentTarget;
          const icons = document.querySelectorAll('.blog__filters__visualization .filter-icon');

          event.stopPropagation();
          event.preventDefault();

          if (!el.classList.contains('filter-icon--active')) {
            if (icons.length) {
              icons.forEach(icon => {
                if (icon === el) {
                  icon.classList.add('filter-icon--active');
                } else {
                  icon.classList.remove('filter-icon--active');
                }
              });
            }

            this.layout = el.getAttribute('data-layout');

            if (this.layout === 'grid') {
              this.order = 'original-order';

              this.grid.arrange({
                sortBy: this.order,
                layoutMode: 'packery'
              });
            } else {
              this.grid.arrange({
                layoutMode: 'vertical'
              });
            }

            this.render();
          }
        });
      });
    }

    if (alphaFilter.length) {
      alphaFilter.forEach(filter => {
        filter.addEventListener('click', event => {
          const el = event.currentTarget;
          const icons = document.querySelectorAll('.blog__filters__visualization .filter-icon');
          const icon = el.querySelector('.filter-icon');

          event.preventDefault();

          this.filters.enabled = true;

          if (this.layout === 'grid') {
            this.layout = 'list';

            if (icons.length) {
              icons.forEach(icon => {
                if (icon.classList.contains('layout-selector--list')) {
                  icon.classList.add('filter-icon--active');
                } else {
                  icon.classList.remove('filter-icon--active');
                }
              });
            }

            this.render();
          }

          if (this.order === 'original-order') {
            this.order = 'category';
            icon.classList.add('filter-icon--active');
          } else {
            this.order = 'original-order';
            icon.classList.remove('filter-icon--active');
          }

          this.grid.arrange({
            sortBy: this.order,
            layoutMode: 'vertical'
          });
        });
      })
    }

    if (backLink) {
      backLink.addEventListener('click', evt => {
        const filter = document.querySelector('#filter-sector-ajax');
        const filters = document.querySelector('.category-filter');

        evt.preventDefault();

        filter.value = 'all';

        this.filters.sector = 'all';

        if (filters) {
          filters.style.display = 'none';
        }

        this.customFiltering();
      });
    }
  }

  fetchData() {
    this.loader.style.display = 'flex';

    return new Promise((resolve) => {
      this.request().then((response) => {
        this.resultHtml = response;
        this.render();

        this.loader.style.display = 'none';
        return resolve();
      }).catch(function (error) {
        console.log(error.message);
      });
    })
  }

  request = async () => {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-WP-Nonce': firac.nonce
    });

    const response = await fetch(firac.url.fairs + firac.lang + '/' + this.filters.year + '/' + this.filters.actuality, {
      headers: headers,
      method: 'GET',
    });

    return await response.json();
  };

  render() {
    const layout = document.querySelector('#fairs-archive-layout');
    const range = document.createRange();
    const template = wp.template(this.layout + '-single');

    if (layout) {
      layout.classList.remove('grid', 'list');
      layout.classList.add(this.layout);
    }

    this.reset().then(() => {
      Object.values(this.resultHtml).map(article => {
        let html = template(article);
        return range.createContextualFragment(html).firstElementChild;
      }).forEach(article => {
        this.wrapper.appendChild(article);
        this.grid.insert(article);
      });
    }).then(() => {
      imagesLoaded(this.wrapper).on('progress', () => {
        this.grid.layout();
      });

      this.grid.reloadItems();
    });
  }

  reset = async () => {
    const gridSizer = document.createElement('div');
    const gutterSizer = document.createElement('div');

    Array.from(this.wrapper.children).forEach(item => {
      this.wrapper.removeChild(item);
      if (item.classList.contains(this.grid.options.itemSelector)) {
        this.grid.remove(item);
      }
    });

    gridSizer.classList.add('grid-sizer');
    gutterSizer.classList.add('gutter-sizer');

    this.wrapper.appendChild(gridSizer);
    this.wrapper.appendChild(gutterSizer);
  };
}

export default FairsArchive;
